export class Gasbca {
   id: number;
   bcaId: number;
   totalLots: number;
   enteredBy: string;
   serviceFormattedAddress: string;
   developmentStatus: string;
  projectCategory: string;
  contractStatus: string;
   projectName: string;
   bcaStatus: string;
  mainInstallationStatus: string;
  mainStatus: string;
   finalPlat: string;
   stateCd: string;
   recCreateDttm: Date;
   recUpdateDttm: string;
   recUpdateUsrId: string;
   recCreateUsrId: string;
 }
